import React from 'react'
import { useTranslation } from 'react-i18next';


const FunFact = (props) => {
    const { i18n } = useTranslation();
    const funfact = [
        {
            title: '18+',
            subTitle: 'Years Of Experience',
            subTitleAr: 'سنوات من الخبرة',
        },
        {
            title: '50+',
            subTitle: 'Expert Specialist',
            subTitleAr: 'خبراء متخصصين',
        },
        {
            title: '125+',
            subTitle: 'Successful Project',
            subTitleAr: 'مشاريع نجاحية',
        },
        {
            title: '79+',
            subTitle: 'Happy Customers',
            subTitleAr: 'عملاء سعيدون',
        },


    ]


    return (

        <section className={`wpo-fun-fact-section pb-120 ${props.fnClass}`}>
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="wpo-fun-fact-grids clearfix">
                            {funfact.map((funfact, fitem) => (
                                <div className="grid" key={fitem}>
                                    <div className="info">
                                        <h3>{funfact.title}</h3>
                                        <p>{i18n.language === "ar" ? funfact.subTitleAr : funfact.subTitle}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FunFact;